/**
 * Import Style
 */
import "~assets/sass/style.scss";

/**
 * Import Modules
 */
import Accordion from "./modules/Accordion";
import Slider from "./modules/Slider";
import Navigation from "./modules/Navigation";
import AmbassadorCard from "./modules/AmbassadorCard";
import Modal from "./modules/Modal";
import Forms from "./modules/Forms";
import Reviews from "./modules/Reviews";
import Visits from "./modules/Visits";
import Toast from "./modules/Toast";
import Datatables from "./modules/Datatables";
import DeleteFiles from "./modules/DeleteFiles";
import Videos from "./modules/Videos";
import Testimonial from "./modules/Testimonial";


window.onload = () => {
    /**
     * Init Sliders
     */
    Slider();

    /**
     * Init Accordions
     */
    Accordion();

    /**
     * Init Navigation mobile
     */
    Navigation();

    /**
     * Init Switch ambassador cards
     */
    AmbassadorCard();

    /**
     * Init Modal
     */
    Modal();

    /**
     * Init Forms
     */
    Forms();

    /**
     * Init Reviews
     */
    Reviews();

    /**
     * Init Visits
     */
    Visits();

    /**
     * Init Toast
     */
    Toast();

    /**
     * Init Datatables
     */
    Datatables();

    /**
     * Init DeleteFiles
     */
    DeleteFiles();

    /**
     * Init Videos
     */
    Videos();

    /**
     * Init Videos
     */
    Testimonial();
}
